// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__iS9KL"};